// What a drawing set was issued as — the colored tag beside a sheet's version:
// "BID", "ADD-1", "RFI-071", "PR-5" (S2-14, K7-21). Shared by the Drawings
// cards, list, Revision History, compare pick list and the sheet viewer.

export const ISSUE_TAG_COLORS = {
  bid:      "bg-slate-200 text-slate-700",
  addendum: "bg-indigo-100 text-indigo-700",
  rfi:      "bg-orange-100 text-orange-700",
  bulletin: "bg-teal-100 text-teal-700",
  asi:      "bg-pink-100 text-pink-700",
  pr:       "bg-violet-100 text-violet-700",
  permit:   "bg-sky-100 text-sky-700",
  ifc:      "bg-emerald-100 text-emerald-700",
  other:    "bg-gray-100 text-gray-600"
}

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]))

// tag = { type, label } from the server (DrawingSet#issue_tag); title = the
// set's full name, shown on hover. No tag → "" (a plain new version).
export function issueTagChip(tag, title = "") {
  if (!tag?.label) return ""
  const colors = ISSUE_TAG_COLORS[tag.type] || ISSUE_TAG_COLORS.other
  const hover = title ? ` title="${esc(title)}"` : ""
  return `<span class="inline-flex items-center rounded px-1.5 py-px text-[13px] font-semibold leading-tight shrink-0 ${colors}"${hover}>${esc(tag.label)}</span>`
}

// Same reading as DrawingSet::NAME_GUESSES (keep the two in step): the upload
// form fills Type + Number from a set name like "Addendum 1" or "PR 5".
const NAME_GUESSES = [
  ["addendum", /\baddend(?:um|a)\b[\s#.:-]*(?:no\.?\s*)?([A-Za-z0-9]{1,6}\b)?/i],
  ["rfi",      /\bRFI\b[\s#.:-]*([A-Za-z0-9]{1,8}\b)?/i],
  ["bulletin", /\bbulletin\b[\s#.:-]*([A-Za-z0-9]{1,6}\b)?/i],
  ["asi",      /\bASI\b[\s#.:-]*([A-Za-z0-9]{1,6}\b)?/i],
  ["pr",       /\b(?:PR|proposal\s+request)(?=[\s#.:-]|\d|$)[\s#.:-]*(?:no\.?\s*)?([A-Za-z0-9]{1,6}\b)?/i],
  ["ifc",      /\b(?:IFC|issued\s+for\s+construction)\b/i],
  ["permit",   /\bpermit\b/i],
  ["bid",      /\bbid(?:ding)?\b/i]
]

// { type, number } — type null when the name says nothing.
export function guessIssueFromName(name) {
  for (const [type, re] of NAME_GUESSES) {
    const m = String(name || "").match(re)
    if (!m) continue
    let num = m[1] || null
    if (num && /^(set|rev|revision|package|pkg)$/i.test(num)) num = null
    return { type, number: num }
  }
  return { type: null, number: null }
}
